export default "__VITE_ASSET__CMXrnjH8__"